// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1maLG","legacyBtn":"MutateMid_legacyBtn__1K6nN"};